import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import { Colors } from '../../theme'

// En celular el panel sube desde abajo como una hoja; en escritorio es una tarjeta centrada.
export const sheetPaperSx = (isMobile) => (isMobile
  ? {
    position: 'absolute',
    bottom: 0,
    m: 0,
    width: '100%',
    maxWidth: '100%',
    maxHeight: '88dvh',
    borderRadius: '24px 24px 0 0',
  }
  : {
    width: '100%',
    maxWidth: 460,
    maxHeight: '80vh',
    borderRadius: '20px',
  })

export const Grabber = styled('span')(() => ({
  alignSelf: 'center',
  width: 40,
  height: 4,
  marginTop: 8,
  borderRadius: 2,
  background: Colors.GRAY_SEPARATOR,
}))

export const PanelHeader = styled('header')(() => ({
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  gap: 12,
  padding: '16px 16px 12px 24px',
  borderBottom: `1px solid ${Colors.GRAY_SEPARATOR}`,
}))

export const PanelTitle = styled(Typography)(() => ({
  color: Colors.BG_START,
  fontSize: '1.25rem',
  fontWeight: 700,
  lineHeight: 1.3,
}))

export const PanelHint = styled(Typography)(() => ({
  marginTop: 2,
  color: Colors.SECONDARY_TEXT,
  fontSize: '0.85rem',
  lineHeight: 1.4,
}))

export const PanelBody = styled('div')(() => ({
  overflowY: 'auto',
  overscrollBehavior: 'contain',
  padding: '4px 0 calc(16px + env(safe-area-inset-bottom))',
}))

export const EnableCard = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: 12,
  margin: '12px 16px 4px',
  padding: '12px 12px 12px 16px',
  borderRadius: 14,
  background: Colors.INFO_SOFT,
}))

export const EnableText = styled(Typography)(() => ({
  flex: 1,
  color: Colors.BG_START,
  fontSize: '0.85rem',
  lineHeight: 1.4,
}))

export const EnableButton = styled(Button)(() => ({
  flexShrink: 0,
  borderRadius: 10,
  background: Colors.BG_START,
  color: Colors.GREEN_BACKGROUND,
  fontWeight: 700,
  textTransform: 'none',
  '@media (hover: hover)': {
    '&:hover': {
      background: Colors.BG_END,
    },
  },
}))

export const DayLabel = styled(Typography)(() => ({
  padding: '16px 24px 6px',
  color: Colors.GRAY_TEXT,
  fontSize: '0.75rem',
  fontWeight: 700,
  letterSpacing: 0.5,
  textTransform: 'uppercase',
}))

export const ItemList = styled('ul')(() => ({
  listStyle: 'none',
  margin: 0,
  padding: '0 8px',
}))

export const Item = styled('li', {
  shouldForwardProp: (prop) => prop !== 'isNew',
})(({ isNew }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 12,
  padding: '10px 16px',
  borderRadius: 14,
  background: isNew ? Colors.NEW_ITEM_BG : Colors.TRANSPARENT,
}))

const KIND_STYLES = {
  on: { background: Colors.SUCCESS_SOFT, color: Colors.SUCCESS },
  off: { background: Colors.GRAY_BACKGROUND, color: Colors.SECONDARY_TEXT },
  alarm: { background: Colors.WARNING_SOFT, color: Colors.WARNING },
  other: { background: Colors.INFO_SOFT, color: Colors.PURPLE },
}

export const KindIcon = styled('span', {
  shouldForwardProp: (prop) => prop !== 'kind',
})(({ kind }) => ({
  flexShrink: 0,
  display: 'grid',
  placeItems: 'center',
  width: 40,
  height: 40,
  borderRadius: 12,
  ...(KIND_STYLES[kind] || KIND_STYLES.other),
}))

export const ItemText = styled('div')(() => ({
  flex: 1,
  minWidth: 0,
}))

export const ItemTop = styled('div')(() => ({
  display: 'flex',
  alignItems: 'baseline',
  justifyContent: 'space-between',
  gap: 8,
}))

export const ItemTitle = styled(Typography)(() => ({
  color: Colors.BG_START,
  fontSize: '0.95rem',
  fontWeight: 700,
  lineHeight: 1.3,
}))

export const ItemTime = styled(Typography)(() => ({
  flexShrink: 0,
  color: Colors.GRAY_TEXT,
  fontSize: '0.75rem',
  fontVariantNumeric: 'tabular-nums',
}))

export const ItemMeta = styled(Typography)(() => ({
  marginTop: 2,
  color: Colors.SECONDARY_TEXT,
  fontSize: '0.85rem',
  lineHeight: 1.35,
}))

export const NewDot = styled('span')(() => ({
  flexShrink: 0,
  width: 8,
  height: 8,
  borderRadius: '50%',
  background: Colors.TEXT_CIAN,
}))

export const EmptyState = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 8,
  padding: '40px 32px 32px',
  textAlign: 'center',
}))

export const EmptyIcon = styled('span')(() => ({
  display: 'grid',
  placeItems: 'center',
  width: 56,
  height: 56,
  marginBottom: 4,
  borderRadius: 18,
  background: Colors.INFO_SOFT,
  color: Colors.PURPLE,
}))

export const EmptyTitle = styled(Typography)(() => ({
  color: Colors.BG_START,
  fontSize: '1rem',
  fontWeight: 700,
}))

export const EmptyText = styled(Typography)(() => ({
  color: Colors.SECONDARY_TEXT,
  fontSize: '0.85rem',
  lineHeight: 1.45,
  maxWidth: 280,
}))
